module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"manufacturer":"Hersteller","serial-number":"Seriennummer","changed":"Geändert"},"fr":{"manufacturer":"Fabricant","serial-number":"Numéro de série","changed":"Modifié"},"it":{"manufacturer":"Fabbricante","serial-number":"No. di serie","changed":"Cambiato"}}')
  delete Component.options._Ctor
}
